import { Component, NgZone } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from 'app/shared/auth/auth.service';
import { User } from 'app/shared/models/user.model';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})

export class LoginPageComponent {

  loginFormSubmitted = false;
  isLoginFailed = false;
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    rememberMe: new FormControl(true)
  });
  user: User;
  currentUrl:any
  constructor(private router: Router, private authService: AuthService,
    private route:ActivatedRoute,private spinner: NgxSpinnerService,
     public toastr: ToastrService) {
      this.currentUrl=this.route.snapshot.routeConfig.path
     } 

  get lf() {
    return this.loginForm.controls;
  }

  onSubmit() {
   

    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      this.loginFormSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.authService.signinUser(this.loginForm.value, this.currentUrl)
  .subscribe((res: any) => {
    this.spinner.hide()
      if (res && res.data.roles === 'admin' || res.data.roles === 'employee') {
        this.router.navigate(['/dashboard'])
      } else {
        this.toastr.error(res.error || 'An error occurred');
      }
  });
  }

}
